import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Avatar, Button, Divider, Drawer, Dropdown, Menu } from "antd";
import { ReactNode, useState } from "react";
import { FaAward } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";
import { IoClose, IoSettingsOutline } from "react-icons/io5";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import langIcon from "../../assets/images/lang-change-icon.svg";
import useGetUserData from "../../hooks/useGetUserData";
import { getSalon } from "../../network/settings";
import queryClient from "../../services/react-query/queryClient";
import { queryKeys } from "../../services/react-query/queryKeys";
import {
  setLocationId,
  setSelectedTeamMember,
} from "../../services/store/slices/calender";
import { emptyStep } from "../../services/store/slices/onboarding";
import { setCurrentLang, setUserData } from "../../services/store/slices/user";
import BrandLogo from "./Header/BrandLogo/BrandLogo";

function SidebarMenu() {
  const navigate = useNavigate();
  const { isLoggedIn, user } = useGetUserData();
  const dispatch = useDispatch();
  const currentLang = useSelector((state: any) => state?.user?.currentLang);
  const intl = useIntl();
  const [clicked, setClicked] = useState(false);
  const handleMenuVisibleChange = (visible: any) => {
    setClicked(visible);
  };
  console.log(user, "useruseruseruseruseruser");
  const { data, isLoading: loadSalonData } = useQuery(
    [queryKeys?.listSalon],
    () => getSalon(user?.salon?.id)
  );
  const getItem = (
    key: string,
    label: string | ReactNode | any,
    children: ReactNode[] | null,
    icon: ReactNode
  ) => ({
    key,
    label,
    children,
    icon,
  });
  // const location = useLocation();
  // const isSettingsPath = location.pathname.includes("/settings");

  // const notification_list: any = [];
  const items = [
    getItem(
      "overview",
      <NavLink
        to={"/overview"}
        className={({ isActive }) =>
          isActive ? "active !text-white" : "inactive"
        }
      >
        {intl.formatMessage({ id: "overview", defaultMessage: "Overview" })}
      </NavLink>,
      null,
      null
    ),
    getItem(
      "calendar",
      <NavLink
        to={"/calendar"}
        className={({ isActive }) =>
          isActive ? "active !text-white" : "inactive"
        }
      >
        {intl.formatMessage({ id: "calendar", defaultMessage: "Calendar" })}
      </NavLink>,
      null,
      null
    ),
    getItem(
      "catalog",
      <NavLink
        to={"/catalog"}
        className={({ isActive }) =>
          isActive ? "active !text-white" : "inactive"
        }
      >
        {intl.formatMessage({ id: "catalog", defaultMessage: "Catalog" })}
      </NavLink>,

      null,
      null
    ),
    getItem(
      "sales",
      <NavLink
        to={"/sales"}
        className={({ isActive }) =>
          isActive ? "active !text-white" : "inactive"
        }
      >
        {intl.formatMessage({ id: "Allsales", defaultMessage: "Sales" })}
      </NavLink>,
      null,
      null
    ),
    // getItem(
    //   "reports",
    //   <NavLink
    //     to={"/reports"}
    //     className={({ isActive }) =>
    //       isActive ? "active !text-white" : "inactive"
    //     }
    //   >
    //     {intl.formatMessage({ id: "reports", defaultMessage: "Reports" })}
    //   </NavLink>,

    //   null,
    //   null
    // ),
    getItem(
      "clients",
      <NavLink
        to={"/clients"}
        className={({ isActive }) =>
          isActive ? "active !text-white" : "inactive"
        }
      >
        {intl.formatMessage({ id: "Clients", defaultMessage: "Clients" })}
      </NavLink>,

      null,
      null
    ),
    // getItem(
    //   "clients",
    //   <NavLink
    //     to={"/clients"}
    //     className={({ isActive }) =>
    //       isActive ? "active !text-white" : "inactive"
    //     }
    //   >
    //     {intl.formatMessage({ id: "Clients", defaultMessage: "Clients" })}
    //   </NavLink>,

    //   null,
    //   null
    // ),

    // getItem('title', 'Title', null, <TagOutlined />),
  ];

  const handelChangeLng = () => {
    dispatch(setCurrentLang(currentLang === "ar" ? "en" : "ar"));
    document
      .getElementsByTagName("html")[0]
      .setAttribute("lang", currentLang === "ar" ? "en" : "ar");
    localStorage.setItem("currentLang", currentLang === "ar" ? "en" : "ar");
    setTimeout(() => {
      // queryClient.clear();
      queryClient.invalidateQueries();
      // window.location.reload();
    }, 500);
  };

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div className="header-wrapper">
      <div className="container">
        <div className="header-content-holder ">
          <div className="logo-holder">
            <BrandLogo />
          </div>
          <Menu
            // theme="dark"
            // mode="inline"
            // theme="dark"
            items={items}
            style={{ width: "100%" }}
            // defaultSelectedKeys={['sub2']}
            mode="horizontal"
            defaultOpenKeys={["sub2"]}
            onClick={({ key }) => {
              navigate("/" + key);
            }}
          />
          <Button
            className="inline-block me-auto md:hidden nav-drawer-btn"
            type="primary"
            onClick={showDrawer}
          >
            <FiMenu size={25} color="#fff" />
          </Button>
          <Drawer
            width={"250px"}
            title=""
            placement={"right"}
            closable={false}
            onClose={onClose}
            open={open}
            className="!bg-color-primary"
          >
            <div className="flex justify-end ">
              <Button
                type="link"
                htmlType="button"
                className=""
                onClick={onClose}
              >
                <IoClose size={20} color="#fff" />
              </Button>
            </div>
            <div className="header-content-holder horizontal-menu">
              <Menu
                theme="dark"
                // mode="inline"
                // theme="dark"
                items={items}
                className="!bg-color-primary !text-white "
                style={{ width: "100%" }}
                // defaultSelectedKeys={['sub2']}
                mode="vertical"
                defaultOpenKeys={["sub2"]}
                onClick={({ key }) => {
                  navigate("/" + key);
                }}
              />
            </div>
          </Drawer>
          {/* <p>{<FormattedMessage id="This field is required" />}</p> */}
          {/* <Search
            placeholder="ابحث هنا"
            onSearch={onSearch}
            className="bg-red-100 w-[200px]  lg:w-[450px] rounded-full"
          /> */}
          {/* <Input placeholder="بحث" prefix={<BiSearchAlt />}
          style={{backgroundColor: "transparent", borderColor : "rgba(176, 176, 192, 1)"}}
          /> */}
          <div className="account-action-holder">
            <Button
              type="link"
              onClick={() => navigate("/settings")}
              icon={<IoSettingsOutline size={22} color="#fff" />}
            />

            {/* <Badge size="small" count={0}>
              <NotificationsIconSVG />
            </Badge> */}

            {/* <div className="search-notify-holder">
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu className="notify-menu-wrapper">
                    {notification_list?.length >= 1 &&
                      notification_list?.map((notify: any) => (
                        <Menu.Item
                          key={notify?.Id}
                          className={notify?.IsSeen ? "seen-bg" : ""}
                        >
                          <Link
                            to={{
                              pathname: "/client",

                            }}
                            className="notify-row-holder"
                          >
                            <div className="notify-icon-holder">
                            </div>
                            <div className="notify-conetnt-holder">
                              <h4>{notify?.TitleLT}</h4>
                              <time>
                                {dayjs
                                  .utc(
                                    notify?.ModifiedDate || notify?.CreationDate
                                  )
                                  .local()
                                  .format("YYYY/M/D  HH:mm:ss")}
                              </time>
                              {+notify?.NotificationTypeId === 1 ? (
                                <Link
                                  to={{
                                    pathname: "/client",
                                  }}
                                >
                                  عرض الطلب
                                </Link>
                              ) : (
                                <Link
                                  to={{
                                    pathname: "/client",
                                  }}
                                >
                                  عرض الرساله
                                </Link>
                              )}
                            </div>
                          </Link>
                        </Menu.Item>
                      ))}
                  </Menu>
                }
              >
                <Badge
                  size="small"
                  count={
                    notification_list?.filter((s: any) => !s?.IsSeen)?.length
                  }
                >
                  <FaRegBell size={22} color="#fff" />
                </Badge>
              </Dropdown>
            </div> */}

            {/* <Button
              type="link"
              onClick={() => alert("Notifications")}
              icon={<NotificationsIconSVG />}
            /> */}

            <Button className="header-lang-btn" onClick={handelChangeLng}>
              {currentLang === "ar" ? "English" : "العربية"}
              <img src={langIcon} alt="" />
            </Button>

            <Dropdown
              overlayClassName="user-dropdown-wrapper "
              trigger={["click"]}
              overlay={
                <Menu className="!p-3 min-w-[210px]">
                  <Menu.Item
                    key="2"
                    icon={
                      <FaAward className="text-color-primary !text-[16px]" />
                    }
                    className="text-[#75757E] !px-0"
                    // onClick={() => this.props.history.push("/profile")}
                  >
                    <div className="flex items-center justify-between w-full">
                      <Link
                        to={`/subscription-plans`}
                        className="text-[#75757E]"
                      >
                        {intl.formatMessage({ id: "pricing_plan" })}
                      </Link>
                      <span className="font-semibold text-color-primary">
                        {data?.data?.subscription_plan?.plan?.name === "Free"
                          ? "Free"
                          : data?.data?.subscription_plan?.plan?.price}
                      </span>
                    </div>
                  </Menu.Item>
                  {/* <Divider className="!text-[#9999A7] my-3" />
                  <Menu.Item
                    key="3"
                    icon={<UserOutlined className="text-color-primary" />}
                    className="text-[#75757E] !px-0"
                  >
                    <Link to={`/`} className="hover:!text-color-primary">
                      {intl.formatMessage({ id: "intl.form.personalAccount" })}
                    </Link>
                  </Menu.Item> */}
                  <Divider className="!text-[#9999A7] my-3" />
                  <Menu.Item
                    className="logout-menu-item text-[#75757E] !px-0 hover:!text-color-danger"
                    key="4"
                    icon={<LogoutOutlined className="" />}
                    onClick={() => {
                      dispatch(setUserData(null));
                      dispatch(setLocationId(null));
                      dispatch(setSelectedTeamMember(null));
                      dispatch(emptyStep([]));
                      queryClient.clear();
                      localStorage.clear();
                      navigate("/login");
                      return;
                    }}
                  >
                    {intl.formatMessage({ id: "intl.form.logout" })}
                  </Menu.Item>
                </Menu>
              }
              onVisibleChange={handleMenuVisibleChange}
              className="login-dropdown !bg-[#8A8A90]"
            >
              <div className="user-login-wrapper">
                <Avatar size={32} src="" icon={<UserOutlined />} />
                <div
                  className={`${
                    clicked ? "w-auto min-w-[25px]" : "w-0"
                  } user-auth-info !text-white duration-300 transition-all overflow-hidden`}
                >
                  <p className="user-name">{user?.name?.[currentLang]}</p>
                  <p className="user-role !text-white mx-2">
                    {user?.salon?.name}
                  </p>
                </div>
                {clicked ? (
                  <MdKeyboardArrowUp color="#fff" size={20} />
                ) : (
                  <MdKeyboardArrowDown color="#fff" size={20} />
                )}
              </div>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SidebarMenu;
